import { render, staticRenderFns } from "./SystemTicketList.vue?vue&type=template&id=7bc13e62&lang=pug&"
import script from "./SystemTicketList.vue?vue&type=script&lang=js&"
export * from "./SystemTicketList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports